module.exports = __webpack_public_path__ + "img/pr-4.cf6a1a0e.png";